/**
 * Map number to currency.
 * @param {string} value
 */
export function toCurrency(value) {
  if (typeof Number(value) !== 'number') {
    return value;
  }
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });
  return formatter.format(value);
}
